import { render } from "./PModifiedData.vue?vue&type=template&id=c72f5a62&scoped=true"
import script from "./PModifiedData.vue?vue&type=script&lang=js"
export * from "./PModifiedData.vue?vue&type=script&lang=js"

import "./PModifiedData.vue?vue&type=style&index=0&id=c72f5a62&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c72f5a62"]])

export default __exports__